import { site } from '../../data/site';

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="wrap footer-inner">
        <div className="footer-legal">
          <img
            className="footer-mark"
            src="/assets/logo-white.png"
            srcSet="/assets/logo-white.png 1x, /assets/logo-white@2x.png 2x"
            alt={site.name.replace(' (Pty) Ltd', '')}
            width={340}
            height={110}
            loading="lazy"
            decoding="async"
          />
          <p className="footer-name">{site.name}</p>
          <p>Registration No. {site.registration}</p>
          <p>
            © {site.copyrightYear} {site.name}
          </p>
        </div>
        <p className="footer-contact">
          <a href={`mailto:${site.email}`}>{site.email}</a>
        </p>
      </div>
    </footer>
  );
}
